import { Component, OnInit, Input} from '@angular/core';

import {Interpretation} from '../../classes/interpretation';

@Component({
  selector: 'app-interpretation',
  templateUrl: './interpretation.component.html',
  styleUrls: ['./interpretation.component.scss']
})
export class InterpretationComponent implements OnInit {

  @Input() interpretation: Interpretation;

  public visible: boolean = false;

  constructor() {}

  ngOnInit() {
  }

  public toggleVisibility() {
    this.visible = !this.visible;
  }

}
